export const sachsoServerUrl = 'https://server.sachso.edu.vn';
export const amesSendMailUrl = 'https://ames.edu.vn/ames/api/amesapi';

export const sachSoUploadFile =
  'https://server.sachso.edu.vn/api/v1.0/dynamic/upload-files';
